import { gql } from 'types/__generated__/gql';

const KEY_EXPORT_ORGANIZATION_REPORT_QUERY = gql(/* GraphQL */ `
  query getOrganizationReportExporting($id: Int!, $dateRange: DateRangeInput!) {
    organization: organization(where: { id: $id }) {
      id
      name
      type
      stats {
        classroomStudentCount
        userCount
        classroomCount
      }
      subOrganizations {
        type
      }
      licenseUsage(where: { productFamily: { code: "KEY" } }) {
        classroomAssignedCount
      }
    }
    activeStudents: keyActiveStudentsReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        activeStudentCount
        totalStudentCount
      }
    }
    activitiesCompleted: keyActivitiesCompletedReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        curriculumActivitiesCompleted {
          productCurriculumCode
          activitiesCompletedCount
        }
        totalActivitiesCompletedCount
      }
    }
    averageWeeklyTimeSpent: keyAverageWeeklyTimeSpentReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        curriculumAverageWeeklyTimeSpent {
          productCurriculumCode
          averageWeeklyMinutesSpent
        }
        averageWeeklyMinutesSpent
      }
    }
    curriculumProgress: keyCurriculumProgressReportAsync(where: { organizationId: $id }) {
      id
      error
      result {
        curriculumProgressPercentage
      }
    }
    schools: keyOrganizationEngagementReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        organization {
          id
          name
          type
          stats {
            classroomStudentCount
            userCount
            classroomCount
          }
          subOrganizations {
            type
          }
          licenseUsage(where: { productFamily: { code: "KEY" } }) {
            classroomAssignedCount
          }
        }
        activeStudentCount
        totalStudentCount
        curriculumActivitiesCompleted {
          productCurriculumCode
          activitiesCompletedCount
        }
        totalActivitiesCompletedCount
        curriculumAverageWeeklyTimeSpent {
          productCurriculumCode
          averageWeeklyMinutesSpent
        }
        averageWeeklyMinutesSpent
        curriculumProgressPercentage
      }
    }
  }
`);

export default KEY_EXPORT_ORGANIZATION_REPORT_QUERY;
